import React from "react";
import { useTranslation } from "react-i18next";
import { ExternalLink } from "lucide-react";
import RemoteAnnouncementContent from "../RemoteAnnouncementContent";

// ─────────────────────────────────────────────────────────────────────────────
// Vista previa del pop-up tal como lo verá el comercio: mismo componente de
// contenido que el portal (RemoteAnnouncementContent) dentro de un marco con
// la forma del modal real. No es interactiva.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * @param {{ title: string, body: string, imageUrl: string, imageAlt: string,
 *   ctaLabel?: string, sender: object }} props
 */
export default function AnnouncementPreview({ title, body, imageUrl, imageAlt, ctaLabel, sender }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-fg-muted">
        {t("Vista previa")}
      </span>
      <div
        className="flex flex-col overflow-hidden rounded-xl border border-border bg-bg shadow-card"
        aria-label={t("Vista previa del pop-up")}
      >
        <div className="border-b border-border px-4 py-3">
          <p className="text-base font-semibold text-fg">{title || t("Título del pop-up")}</p>
        </div>
        <div className="px-4 py-4">
          <RemoteAnnouncementContent announcement={{ body, imageUrl, imageAlt, sender }} />
        </div>
        <div className="flex flex-wrap items-center gap-3 border-t border-border px-4 py-3">
          <span className="mr-auto flex items-center gap-2 text-sm text-fg-muted">
            <span className="h-4 w-4 rounded border border-border" aria-hidden="true" />
            {t("No volver a mostrar este aviso")}
          </span>
          <span className="inline-flex h-8 items-center gap-2 rounded-md bg-brand-500 px-3 text-sm font-medium text-white">
            {ctaLabel ? (
              <>
                <ExternalLink className="h-4 w-4" aria-hidden="true" />
                {ctaLabel}
              </>
            ) : (
              t("Entendido")
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
